import type {Icon} from '@primer/octicons-react'
import {CounterLabel} from '@primer/react'
import {Count} from '@github-ui/count'
import {CollapsibleNavList} from '@github-ui/layout-primitives/CollapsibleNavList'

export type AIResourceSearchCategory = {
  label: string
  href: string
  icon: Icon
  count?: number
  current?: boolean
}

export function SearchCategoryNav({categories}: {categories: readonly AIResourceSearchCategory[]}) {
  return (
    <CollapsibleNavList aria-label="Search categories">
      {categories.map(category => (
        <CollapsibleNavList.LinkItem
          key={`${category.label}-${category.href}`}
          to={category.href}
          label={category.label}
          icon={category.icon}
          aria-current={category.current ? 'page' : undefined}
          trailingVisual={
            category.count === undefined ? undefined : (
              <CounterLabel>
                <Count value={category.count} />
              </CounterLabel>
            )
          }
          forceHardNavigation
        />
      ))}
    </CollapsibleNavList>
  )
}
